
export default class OptionItem {

    Id: number | string;
    Text: string;
    Value: any;

    constructor(id: number | string, name: string, value: any) {
        this.Id = id;
        this.Text = name;
        this.Value = value;
    }

    static NewInstance() {
        return new OptionItem(0, "", undefined);
    }
}